import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { cta, BRAND } from "@/lib/site";

export const Header = () => {
  return (
    <motion.header
      initial={{ y: -40, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.9, delay: 0.1, ease: [0.22, 1, 0.36, 1] }}
      className="fixed top-0 inset-x-0 z-50 backdrop-blur-[2px] bg-[#F7F5F0]/85 border-b border-[#E4DFD4]"
      data-testid="site-header"
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-12 h-16 flex items-center justify-between">
        <a
          href="/"
          className="flex items-center gap-2 group"
          data-testid="site-logo-link"
        >
          <span className="w-2 h-2 rounded-full bg-[#D93829]" />
          <span className="font-serif-display text-lg tracking-tight text-[#1C1C1A]">
            {BRAND.wordmark}
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-8 text-[13px] uppercase tracking-[0.18em] text-[#68655E]">
          <a
            href="#manifesto"
            className="link-underline hover:text-[#1C1C1A] transition-colors"
            data-testid="nav-manifesto"
          >
            Manifesto
          </a>
          <a
            href="#gallery"
            className="link-underline hover:text-[#1C1C1A] transition-colors"
            data-testid="nav-gallery"
          >
            The Cards
          </a>
          <a
            href="#faq"
            className="link-underline hover:text-[#1C1C1A] transition-colors"
            data-testid="nav-faq"
          >
            FAQ
          </a>
          <a
            href="#send"
            className="link-underline hover:text-[#1C1C1A] transition-colors"
            data-testid="nav-send"
          >
            Send One
          </a>
        </nav>

        <a
          href={cta("header")}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="header-cta"
          className="group inline-flex items-center gap-2 px-4 py-2 bg-[#1C1C1A] text-[#F7F5F0] text-[12px] uppercase tracking-[0.18em] font-medium rounded-full hover:bg-[#D93829] transition-colors duration-500"
        >
          Send a Postcard
          <ArrowUpRight
            size={14}
            className="transition-transform duration-500 group-hover:rotate-45"
          />
        </a>
      </div>
    </motion.header>
  );
};

export default Header;
